import React, { useMemo, useState } from 'react';
import { makeMatchName } from '../../billMemory/core';

/**
 * Bill Memory red card (source spec, "Stock In screen behaviour"; design D4): the three plain
 * choices for a row no inventory item fits. Nothing is chosen on the user's behalf — no default.
 * "Pick from inventory" searches inside the card, not in a popup. Today's chip and text styles only.
 */
export default function RedCardActions({ row, inventoryItems, onAddNew, onNonConsumable, onPick }) {
  const [searching, setSearching] = useState(false);
  const [query, setQuery] = useState('');

  const matches = useMemo(() => {
    const q = makeMatchName(query);
    if (!q) return [];
    return (inventoryItems || [])
      .filter((it) => it && it.name && makeMatchName(it.name).includes(q))
      .slice(0, 8);
  }, [query, inventoryItems]);

  return (
    <div className="bm-red-card" data-row={row && row.uid}>
      <div className="suggestions-row">
        <button type="button" className="suggestion-chip" onClick={() => onAddNew && onAddNew()}>Add as new ingredient</button>
        <button type="button" className="suggestion-chip" onClick={() => onNonConsumable && onNonConsumable()}>Non-consumable</button>
        <button type="button" className="suggestion-chip" onClick={() => setSearching((s) => !s)}>Pick from inventory</button>
      </div>
      {searching && (
        <div className="bm-red-card-search">
          <input
            type="text"
            className="item-input"
            autoFocus
            value={query}
            placeholder="Search your items"
            onChange={(e) => setQuery(e.target.value)}
          />
          <div className="suggestions-row">
            {matches.map((it) => (
              <button key={it.item_id || it.name} type="button" className="suggestion-chip" onClick={() => onPick && onPick(it)}>
                {it.name}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
